import type { LifeEvent } from '../../types/onelife.ts';

export const YOUTH_EVENTS: LifeEvent[] = [
  {
    "id": "yo_01_dorm_life",
    "stageKey": "youth",
    "age": 19,
    "titleVi": "Cuộc Sống Ký Túc Xá Sinh Viên",
    "descriptionVi": "Lần đầu tiên sống tự lập trong căn phòng ký túc xá 8 người với đủ bạn bè từ khắp các vùng miền.",
    "category": "society",
    "choices": [
      {
        "id": "yo_01_a",
        "textVi": "Chủ động tổ chức nấu ăn chung và lập quỹ tiết kiệm phòng",
        "outcomeTextVi": "Bạn rèn được khả năng hòa nhập tuyệt vời và quản lý chi tiêu hiệu quả.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 10,
        "intellectDelta": 10,
        "relationsDelta": 25
      },
      {
        "id": "yo_01_b",
        "textVi": "Dành phần lớn thời gian ở thư viện học tập và tự nghiên cứu",
        "outcomeTextVi": "Kết quả học tập xuất sắc đưa bạn vào danh sách nhận học bổng trường.",
        "healthDelta": -5,
        "happinessDelta": 15,
        "wealthDelta": 15,
        "intellectDelta": 25,
        "relationsDelta": 5
      }
    ]
  },
  {
    "id": "yo_02_marriage_prep",
    "stageKey": "youth",
    "age": 23,
    "titleVi": "Lớp Giáo Lý Hôn Nhân & Chuẩn Bị Gia Đình",
    "descriptionVi": "Bạn cùng người yêu đăng ký khóa học Giáo Lý Hôn Nhân tại giáo xứ để chuẩn bị tiến tới Bí Tích Hôn Phối.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "yo_02_a",
        "textVi": "Sốt sắng học hỏi về đặc tính duy nhất và bất khả phân ly của Bí Tích Hôn Phối",
        "outcomeTextVi": "Cả hai thấu hiểu sâu sắc nền tảng tình yêu dâng hiến và trách nhiệm thiêng liêng xây dựng tổ ấm.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 25,
        "addVirtue": "Tôn trọng sự thánh thiêng của đời sống gia đình và Bí Tích Hôn Phối"
      },
      {
        "id": "yo_02_b",
        "textVi": "Lắng nghe kinh nghiệm từ các gia đình Công giáo kỳ cựu chia sẻ",
        "outcomeTextVi": "Học hỏi được nghệ thuật nhẫn nhịn và giải quyết xung đột bằng lời cầu nguyện chung.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "yo_03_first_internship",
    "stageKey": "youth",
    "age": 21,
    "titleVi": "Kỳ Thực Tập Doanh Nghiệp",
    "descriptionVi": "Bạn được nhận vào thực tập tại một tập đoàn công nghệ / tài chính đa quốc gia uy tín.",
    "category": "career",
    "choices": [
      {
        "id": "yo_03_a",
        "textVi": "Chủ động nhận việc khó, làm thêm giờ học hỏi đàn anh kỳ cựu",
        "outcomeTextVi": "Sếp lớn ấn tượng mạnh và ký hợp đồng tuyển dụng chính thức ngay khi chưa tốt nghiệp.",
        "healthDelta": -5,
        "happinessDelta": 25,
        "wealthDelta": 25,
        "intellectDelta": 25,
        "relationsDelta": 20,
        "careerTag": "Kỹ Sư Công Nghệ Chính Thức",
        "unlockAchievement": "Thực Tập Sinh Xuất Sắc"
      },
      {
        "id": "yo_03_b",
        "textVi": "Tập trung xây dựng mạng lưới quan hệ đồng nghiệp thân thiện",
        "outcomeTextVi": "Bạn hòa đồng nhanh chóng, được đồng nghiệp hết lòng hỗ trợ và chỉ dẫn bí quyết nghề.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 10,
        "intellectDelta": 15,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "yo_04_startup_attempt",
    "stageKey": "youth",
    "age": 22,
    "titleVi": "Khởi Nghiệp Tuổi Đôi Mươi",
    "descriptionVi": "Cùng 2 người bạn hùn vốn mở quán cà phê sách hoặc phát triển ứng dụng di động đầu tay.",
    "category": "career",
    "choices": [
      {
        "id": "yo_04_a",
        "textVi": "Dốc toàn lực nghiên cứu sản phẩm, chăm sóc từng khách hàng đầu tiên",
        "outcomeTextVi": "Dự án có doanh thu hòa vốn sau 6 tháng, tạo đà bứt phá cho thương hiệu.",
        "healthDelta": -10,
        "happinessDelta": 25,
        "wealthDelta": 30,
        "intellectDelta": 25,
        "relationsDelta": 20,
        "careerTag": "Nhà Sáng Lập Khởi Nghiệp"
      },
      {
        "id": "yo_04_b",
        "textVi": "Gặp biến cố thị trường nhưng kiên trì rút kinh nghiệm xương máu",
        "outcomeTextVi": "Dù dự án tạm dừng nhưng bài học quản trị là tài sản vô giá không trường lớp nào dạy được.",
        "healthDelta": -5,
        "happinessDelta": 10,
        "wealthDelta": -20,
        "intellectDelta": 30,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "yo_05_deep_romance",
    "stageKey": "youth",
    "age": 22,
    "titleVi": "Hẹn Hò & Lời Hứa Trăm Năm",
    "descriptionVi": "Tình yêu trưởng thành qua năm tháng, cùng nhau dạo bước dưới ánh hoàng hôn ngắm dòng sông êm đềm.",
    "category": "love",
    "choices": [
      {
        "id": "yo_05_a",
        "textVi": "Cầu hôn lãng mạn bên bờ biển với chiếc nhẫn đơn sơ nhưng chân thành",
        "outcomeTextVi": "Người ấy xúc động rơi nước mắt gật đầu đồng ý trong niềm hân hoan tột cùng.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": -15,
        "intellectDelta": 5,
        "relationsDelta": 30,
        "unlockRelationship": "Đã Đính Hôn Chuẩn Bị Cưới"
      },
      {
        "id": "yo_05_b",
        "textVi": "Cùng nhau lập kế hoạch tích lũy tài chính 2 năm trước khi làm đám cưới",
        "outcomeTextVi": "Sự chín chắn và đồng lòng giúp tình cảm hai bạn ngày càng bền chặt như bàn thạch.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 15,
        "intellectDelta": 15,
        "relationsDelta": 25,
        "unlockRelationship": "Người Yêu Đồng Cam Cộng Khổ"
      }
    ]
  },
  {
    "id": "yo_06_military_service",
    "stageKey": "youth",
    "age": 20,
    "titleVi": "Lên Đường Nhập Ngũ Bảo Vệ Tổ Quốc",
    "descriptionVi": "Bạn nhận lệnh gọi nhập ngũ, khoác lên mình màu áo xanh người lính bộ đội cụ Hồ.",
    "category": "society",
    "choices": [
      {
        "id": "yo_06_a",
        "textVi": "Khắc phục gian khổ, rèn luyện kỷ luật thép và ý chí quật cường nơi thao trường",
        "outcomeTextVi": "Hai năm quân ngũ tôi luyện bạn thành một người đàn ông rắn rỏi, kiên cường.",
        "healthDelta": 25,
        "happinessDelta": 15,
        "wealthDelta": 10,
        "intellectDelta": 10,
        "relationsDelta": 25,
        "addVirtue": "Lòng yêu nước quả cảm và tinh thần kỷ luật tự giác cao độ"
      },
      {
        "id": "yo_06_b",
        "textVi": "Tích cực tham gia ban văn thể mỹ và giúp đỡ các đồng đội trẻ",
        "outcomeTextVi": "Bạn được trao tặng danh hiệu Chiến sĩ thi đua toàn quân đoàn.",
        "healthDelta": 20,
        "happinessDelta": 20,
        "wealthDelta": 5,
        "intellectDelta": 15,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "yo_07_overseas_scholarship",
    "stageKey": "youth",
    "age": 22,
    "titleVi": "Học Bổng Toàn Phần Du Học Thạc Sĩ",
    "descriptionVi": "Hồ sơ nghiên cứu khoa học của bạn được viện đại học hàng đầu châu Âu / Nhật Bản cấp học bổng danh giá.",
    "category": "education",
    "choices": [
      {
        "id": "yo_07_a",
        "textVi": "Quyết định xách ba lô bay sang chân trời mới để tiếp thu tinh hoa thế giới",
        "outcomeTextVi": "Tầm nhìn quốc tế và kiến thức đỉnh cao nâng tầm tương lai của bạn.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 25,
        "intellectDelta": 35,
        "relationsDelta": 15,
        "unlockPlacesLived": "Châu Âu Văn Minh",
        "unlockEducation": "Thạc Sĩ Quốc Tế Xuất Sắc"
      },
      {
        "id": "yo_07_b",
        "textVi": "Chọn ở lại phụng dưỡng cha mẹ già và học cao học trong nước",
        "outcomeTextVi": "Chữ hiếu vẹn tròn, bạn vẫn thăng tiến vững chắc trong sự nghiệp tại quê hương.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 10,
        "intellectDelta": 25,
        "relationsDelta": 30,
        "addVirtue": "Trọng chữ hiếu hơn danh vọng cá nhân nơi xứ người"
      }
    ]
  },
  {
    "id": "yo_08_blue_collar_master",
    "stageKey": "youth",
    "age": 21,
    "titleVi": "Học Nghề Thợ Hàn / Cơ Khí Chính Xác",
    "descriptionVi": "Bạn chọn con đường trở thành kỹ thuật viên lành nghề với chứng chỉ thợ bậc cao quốc tế.",
    "category": "career",
    "choices": [
      {
        "id": "yo_08_a",
        "textVi": "Cần cù tôi luyện từng đường hàn thẩm mỹ và đọc bản vẽ cơ khí thành thạo",
        "outcomeTextVi": "Bạn được các tập đoàn đóng tàu săn đón với mức lương cao ngất.",
        "healthDelta": 10,
        "happinessDelta": 20,
        "wealthDelta": 35,
        "intellectDelta": 15,
        "relationsDelta": 15,
        "careerTag": "Kỹ Thuật Viên Cơ Khí Lành Nghề"
      },
      {
        "id": "yo_08_b",
        "textVi": "Mở xưởng sửa chữa cơ khí nhỏ tại địa phương phục vụ bà con",
        "outcomeTextVi": "Uy tín trung thực giúp xưởng bạn luôn nườm nượp khách quen.",
        "healthDelta": 10,
        "happinessDelta": 25,
        "wealthDelta": 30,
        "intellectDelta": 15,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "yo_09_parish_youth_leader",
    "stageKey": "youth",
    "age": 21,
    "titleVi": "Trưởng Ban Giới Trẻ Giáo Xứ",
    "descriptionVi": "Cha xứ tín nhiệm bầu bạn làm Trưởng Ban Giới Trẻ phụ trách tổ chức Đại Hội Giới Trẻ Giáo Hạt.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "yo_09_a",
        "textVi": "Nhiệt thành quy tụ các bạn trẻ, tổ chức đêm diễn nguyện Thánh Ca tràn ngập lửa mến",
        "outcomeTextVi": "Đại hội thành công rực rỡ, hàng trăm bạn trẻ tìm lại động lực sống đạo nhiệt thành.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 35,
        "addVirtue": "Dấn thân phục vụ cộng đoàn giới trẻ với tinh thần nhiệt thành Tin Mừng"
      },
      {
        "id": "yo_09_b",
        "textVi": "Tổ chức chuyến thăm các trại phong và trẻ mồ côi vùng sâu vùng xa",
        "outcomeTextVi": "Tình bác ái thực tế chạm tới trái tim người nghèo khổ, được giáo xứ hết lời ngợi khen.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "yo_10_first_savings",
    "stageKey": "youth",
    "age": 23,
    "titleVi": "Sổ Tiết Kiệm Trăm Triệu Đầu Tiên",
    "descriptionVi": "Sau 3 năm đi làm chăm chỉ và chi tiêu khoa học, bạn tích lũy được khoản tiền tiết kiệm đầu tiên.",
    "category": "career",
    "choices": [
      {
        "id": "yo_10_a",
        "textVi": "Gửi tiết kiệm ngân hàng kỳ hạn dài làm quỹ dự phòng an toàn",
        "outcomeTextVi": "Sự an tâm về tài chính giúp bạn tự tin nắm bắt các cơ hội lớn trong tương lai.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 30,
        "intellectDelta": 15,
        "relationsDelta": 10
      },
      {
        "id": "yo_10_b",
        "textVi": "Trích một phần mua bảo hiểm sức khỏe tặng cha mẹ già",
        "outcomeTextVi": "Món quà hiếu thảo thiết thực khiến cha mẹ vô cùng ấm lòng và tự hào.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 15,
        "intellectDelta": 15,
        "relationsDelta": 30,
        "addVirtue": "Hiếu thảo phụng dưỡng cha mẹ khi vừa tự chủ tài chính"
      }
    ]
  },
  {
    "id": "yo_11_gym_fitness",
    "stageKey": "youth",
    "age": 20,
    "titleVi": "Phong Trào Rèn Luyện Thể Hình Calisthenics",
    "descriptionVi": "Bạn duy trì thói quen tập gym hoặc chạy bộ 5km mỗi sáng sớm quanh hồ nước.",
    "category": "health",
    "choices": [
      {
        "id": "yo_11_a",
        "textVi": "Kỷ luật tập luyện 5 buổi/tuần, dinh dưỡng lành mạnh",
        "outcomeTextVi": "Chỉ số sức khỏe đạt chuẩn hoàn hảo, tinh thần minh mẫn và tràn đầy năng lượng tích cực.",
        "healthDelta": 25,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 15
      },
      {
        "id": "yo_11_b",
        "textVi": "Tham gia giải chạy Marathon 21km bán chuyên nghiệp",
        "outcomeTextVi": "Bạn hoàn thành cự ly bán marathon với nụ cười tự hào trên môi.",
        "healthDelta": 25,
        "happinessDelta": 25,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 20,
        "unlockAchievement": "Vận Động Viên Marathon"
      }
    ]
  },
  {
    "id": "yo_12_heartbreak",
    "stageKey": "youth",
    "age": 23,
    "titleVi": "Nỗi Buồn Chia Tay Tình Đầu",
    "descriptionVi": "Khoảng cách địa lý hoặc hướng đi khác biệt khiến hai người quyết định dừng lại trong văn minh.",
    "category": "love",
    "choices": [
      {
        "id": "yo_12_a",
        "textVi": "Tôn trọng quyết định của người ấy, cầu chúc họ bình an trên con đường mới",
        "outcomeTextVi": "Nỗi đau được xoa dịu bằng sự bao dung, giúp bạn trưởng thành chín chắn hơn trong tình yêu.",
        "healthDelta": 0,
        "happinessDelta": 5,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 15,
        "addVirtue": "Hành xử bao dung, văn minh khi khép lại một chuyện tình"
      },
      {
        "id": "yo_12_b",
        "textVi": "Dồn hết tâm trí vào công việc và các khóa học nâng cao kỹ năng",
        "outcomeTextVi": "Sự nghiệp thăng tiến thần tốc, bạn trở thành phiên bản tốt hơn của chính mình.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 20,
        "intellectDelta": 25,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "yo_13_workplace_ethics",
    "stageKey": "youth",
    "age": 24,
    "titleVi": "Thử Thách Đạo Đức Nghề Nghiệp",
    "descriptionVi": "Một đối tác đề nghị lại quả phần trăm hoa hồng dưới gầm bàn để bạn bỏ qua lỗi chất lượng vật liệu.",
    "category": "career",
    "choices": [
      {
        "id": "yo_13_a",
        "textVi": "Kiên quyết từ chối hối lộ và yêu cầu nghiệm thu đúng quy chuẩn kỹ thuật",
        "outcomeTextVi": "Lương tâm bạn thanh thản tuyệt đối, ban giám đốc tin tưởng bổ nhiệm bạn vào ban thanh tra.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20,
        "addVirtue": "Liêm chính tuyệt đối trước cám dỗ vật chất bất chính"
      },
      {
        "id": "yo_13_b",
        "textVi": "Báo cáo ngay sự việc lên phòng pháp chế bảo vệ uy tín công ty",
        "outcomeTextVi": "Bạn cứu công ty khỏi thiệt hại hàng tỷ đồng, được khen thưởng công khai.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 20,
        "intellectDelta": 20,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "yo_14_buying_first_bike",
    "stageKey": "youth",
    "age": 21,
    "titleVi": "Mua Chiếc Xe Máy Mới Bằng Tiền Tự Kiếm",
    "descriptionVi": "Cầm trên tay chìa khóa chiếc xe máy mới tinh do chính mồ hôi công sức mình làm ra.",
    "category": "career",
    "choices": [
      {
        "id": "yo_14_a",
        "textVi": "Chở mẹ và người yêu đi vòng quanh phố phường ngắm cảnh đêm",
        "outcomeTextVi": "Niềm vui rạng rỡ của người thân là phần thưởng quý giá nhất cho những nỗ lực của bạn.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": -20,
        "intellectDelta": 5,
        "relationsDelta": 25
      },
      {
        "id": "yo_14_b",
        "textVi": "Bảo dưỡng xe cẩn thận, dùng làm phương tiện mở rộng công việc kinh doanh",
        "outcomeTextVi": "Phương tiện mới giúp bạn linh hoạt gặp gỡ nhiều khách hàng tiềm năng.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 10,
        "intellectDelta": 10,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "yo_15_pilgrimage_lavang",
    "stageKey": "youth",
    "age": 24,
    "titleVi": "Hành Hương Về Đất Mẹ La Vang",
    "descriptionVi": "Chuyến hành hương linh thiêng về Trung Tâm Thánh Mẫu La Vang cùng đoàn giới trẻ.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "yo_15_a",
        "textVi": "Thành tâm quỳ gối dưới chân Đức Mẹ dâng trọn tương lai và người bạn đời",
        "outcomeTextVi": "Mẹ La Vang nâng đỡ, bạn tìm được sự bình an kỳ diệu và định hướng cuộc đời sáng tỏ.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 20,
        "addVirtue": "Tận hiến cuộc đời dưới sự chở che của Đức Mẹ Maria"
      },
      {
        "id": "yo_15_b",
        "textVi": "Tham gia kiệu hoa và phụ trách trật tự cho đoàn hành hương hàng vạn người",
        "outcomeTextVi": "Tinh thần phục vụ vô vị lợi được mọi người yêu mến, khen ngợi.",
        "healthDelta": 10,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "yo_16_renting_apartment",
    "stageKey": "youth",
    "age": 23,
    "titleVi": "Thuê Căn Hộ Chung Cư Nhỏ Độc Lập",
    "descriptionVi": "Rời phòng trọ chật chội, bạn thuê một căn hộ mini ấm cúng có góc làm việc riêng và ban công nhiều cây xanh.",
    "category": "society",
    "choices": [
      {
        "id": "yo_16_a",
        "textVi": "Tự tay sơn tường, trồng hoa hồng và nấu những bữa ăn đủ dinh dưỡng",
        "outcomeTextVi": "Chất lượng sống được cải thiện rõ rệt, bạn luôn tràn đầy cảm hứng sáng tạo.",
        "healthDelta": 15,
        "happinessDelta": 25,
        "wealthDelta": -15,
        "intellectDelta": 10,
        "relationsDelta": 15
      },
      {
        "id": "yo_16_b",
        "textVi": "Mời bạn bè và đồng nghiệp đến ăn tân gia ấm cúng",
        "outcomeTextVi": "Tình cảm anh em gắn bó, không khí gia đình chan hòa nơi đất khách.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": -10,
        "intellectDelta": 5,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "yo_17_professional_cert",
    "stageKey": "youth",
    "age": 24,
    "titleVi": "Thi Chứng Chỉ Nghề Nghiệp Quốc Tế (CFA / PMP / AWS)",
    "descriptionVi": "3 tháng thức khuya dậy sớm ôn thi chứng chỉ chuyên gia có giá trị toàn cầu.",
    "category": "education",
    "choices": [
      {
        "id": "yo_17_a",
        "textVi": "Vượt qua kỳ thi với điểm số cao, được cấp bằng chuyên gia quốc tế",
        "outcomeTextVi": "Mức lương của bạn tăng vọt 40%, được thăng chức trưởng nhóm kỹ thuật.",
        "healthDelta": -5,
        "happinessDelta": 25,
        "wealthDelta": 35,
        "intellectDelta": 30,
        "relationsDelta": 15,
        "unlockAchievement": "Chuyên Gia Chuẩn Quốc Tế"
      },
      {
        "id": "yo_17_b",
        "textVi": "Áp dụng ngay kiến thức đã học vào cải tiến quy trình công ty",
        "outcomeTextVi": "Hiệu suất nhóm tăng vọt, ban giám đốc thưởng nóng cho cả phòng.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 25,
        "intellectDelta": 25,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "yo_18_family_support",
    "stageKey": "youth",
    "age": 22,
    "titleVi": "Gửi Tiền Về Quê Nuôi Em Học Đại Học",
    "descriptionVi": "Em út của bạn thi đỗ đại học tại thủ đô, chi phí học phí và sinh hoạt tăng cao.",
    "category": "family",
    "choices": [
      {
        "id": "yo_18_a",
        "textVi": "Nhận chu cấp toàn bộ tiền sinh hoạt phí và sách vở cho em",
        "outcomeTextVi": "Người anh/chị cả mẫu mực, gia đình vô cùng tự hào và yêu thương bạn.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": -20,
        "intellectDelta": 5,
        "relationsDelta": 35,
        "addVirtue": "Trách nhiệm hy sinh đùm bọc các em nên người"
      },
      {
        "id": "yo_18_b",
        "textVi": "Hướng dẫn em tìm việc làm thêm phù hợp để vừa học vừa rèn kỹ năng",
        "outcomeTextVi": "Em bạn nhanh chóng trưởng thành và tự lập từ sớm.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "yo_19_traffic_near_miss",
    "stageKey": "youth",
    "age": 21,
    "titleVi": "Hú Vía Tránh Tai Nạn Trên Cao Tốc",
    "descriptionVi": "Một chiếc xe tải bất ngờ tạt đầu trong đêm mưa, bạn phải xử lý tình huống cực kỳ khẩn cấp.",
    "category": "health",
    "choices": [
      {
        "id": "yo_19_a",
        "textVi": "Bình tĩnh giữ chắc tay lái, nhấp phanh chuẩn xác tấp vào làn an toàn",
        "outcomeTextVi": "Xe dừng an toàn trong gang tấc! Bạn thở phào cảm tạ ơn trên chở che bảo vệ.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 10,
        "addVirtue": "Bình tĩnh phi thường trước hiểm nguy gang tấc"
      },
      {
        "id": "yo_19_b",
        "textVi": "Quyết định từ nay luôn điềm đạm, không bao giờ phóng nhanh vượt ẩu",
        "outcomeTextVi": "Bài học đắt giá giúp bạn lái xe an toàn tuyệt đối suốt cuộc đời.",
        "healthDelta": 10,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "yo_20_blood_donation",
    "stageKey": "youth",
    "age": 22,
    "titleVi": "Hiến Máu Tình Nguyện Cứu Người",
    "descriptionVi": "Bệnh viện phát động lời kêu gọi khẩn cấp do ngân hàng máu nhóm hiếm bị cạn kiệt sau đợt bão lụt.",
    "category": "society",
    "choices": [
      {
        "id": "yo_20_a",
        "textVi": "Ngay lập tức đến bệnh viện hiến 350ml máu",
        "outcomeTextVi": "Giọt máu nghĩa tình của bạn kịp thời cứu sống một ca mổ cấp cứu hiểm nghèo.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 25,
        "addVirtue": "Sẵn sàng sẻ chia giọt máu hồng cứu giúp đồng bào trong hoạn nạn"
      },
      {
        "id": "yo_20_b",
        "textVi": "Vận động cả câu lạc bộ thể thao cùng tham gia hiến máu",
        "outcomeTextVi": "Hơn 20 đơn vị máu được bổ sung, lan tỏa nghĩa cử cao đẹp ra cộng đồng.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "yo_21_craftsman_award",
    "stageKey": "youth",
    "age": 25,
    "titleVi": "Bàn Tay Vàng Hội Thi Thợ Giỏi",
    "descriptionVi": "Bạn tham gia hội thi tay nghề kỹ thuật giỏi cấp thành phố ngành chế tác / kỹ thuật.",
    "category": "career",
    "choices": [
      {
        "id": "yo_21_a",
        "textVi": "Hoàn thành bài thi xuất sắc với độ chính xác đến từng micromet",
        "outcomeTextVi": "Bạn được vinh danh Bàn Tay Vàng và được tặng thưởng chuyến tu nghiệp nước ngoài.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 30,
        "intellectDelta": 25,
        "relationsDelta": 20,
        "careerTag": "Nghệ Nhân Bàn Tay Vàng"
      },
      {
        "id": "yo_21_b",
        "textVi": "Chia sẻ kinh nghiệm thao tác máy an toàn cho các thí sinh trẻ tuổi hơn",
        "outcomeTextVi": "Tinh thần đồng đội cao đẹp được hội đồng giám khảo đánh giá rất cao.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 15,
        "intellectDelta": 15,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "yo_22_spiritual_confession",
    "stageKey": "youth",
    "age": 25,
    "titleVi": "Xét Mình Trước Khi Bước Vào Đời Sống Hôn Nhân",
    "descriptionVi": "Trước ngày cưới hoặc dấu mốc trọng đại, bạn đến tòa giải tội lãnh nhận Bí Tích Hòa Giải với tâm hồn sốt sắng.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "yo_22_a",
        "textVi": "Thành tâm sám hối mọi lỗi lầm quá khứ trong Bí Tích Hòa Giải",
        "outcomeTextVi": "Ơn tha thứ của Chúa đổi mới tâm hồn bạn, sẵn sàng cho một chương đời thánh thiện.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 25,
        "addSacrament": "Bí Tích Hòa Giải",
        "addVirtue": "Thanh tẩy tâm hồn bằng Bí Tích Hòa Giải để đón nhận ân sủng mới"
      },
      {
        "id": "yo_22_b",
        "textVi": "Cùng người bạn đời quỳ cầu nguyện trước Thánh Thể",
        "outcomeTextVi": "Ngọn lửa tình yêu được thánh hóa trong ân sủng Chúa Kitô.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "yo_23_mentoring_junior",
    "stageKey": "youth",
    "age": 24,
    "titleVi": "Dìu Dắt Đàn Em Khóa Dưới",
    "descriptionVi": "Bạn nhận hướng dẫn đồ án tốt nghiệp và chia sẻ kinh nghiệm phỏng vấn cho các sinh viên năm cuối.",
    "category": "society",
    "choices": [
      {
        "id": "yo_23_a",
        "textVi": "Tận tình chỉnh sửa từng dòng code, hướng dẫn tư duy giải quyết vấn đề",
        "outcomeTextVi": "Cả nhóm đàn em đều bảo vệ đồ án xuất sắc và tìm được việc làm tốt.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 30,
        "addVirtue": "Hết lòng nâng đỡ và truyền thụ tri thức cho thế hệ đàn em"
      },
      {
        "id": "yo_23_b",
        "textVi": "Tổ chức các buổi chia sẻ kỹ năng mềm và quản lý tài chính sinh viên",
        "outcomeTextVi": "Bạn trở thành người anh/người chị truyền cảm hứng của khoa.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "yo_24_emergency_fund",
    "stageKey": "youth",
    "age": 25,
    "titleVi": "Ứng Phó Khủng Hoảng Kinh Tế Toàn Cầu",
    "descriptionVi": "Làn sóng cắt giảm nhân sự càn quét nhiều công ty lớn, bạn phải đưa ra quyết định tài chính khôn ngoan.",
    "category": "career",
    "choices": [
      {
        "id": "yo_24_a",
        "textVi": "Chủ động học thêm công nghệ mới AI/Tự động hóa nâng cao giá trị bản thân",
        "outcomeTextVi": "Bạn không những không bị ảnh hưởng mà còn được giao trọng trách lớn hơn.",
        "healthDelta": -5,
        "happinessDelta": 20,
        "wealthDelta": 25,
        "intellectDelta": 30,
        "relationsDelta": 15
      },
      {
        "id": "yo_24_b",
        "textVi": "Duy trì quỹ khẩn cấp 6 tháng chi phí và sống tối giản",
        "outcomeTextVi": "Gia đình bạn vượt qua giai đoạn khó khăn một cách bình an vô sự.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 20,
        "intellectDelta": 15,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "yo_25_cooking_mastery",
    "stageKey": "youth",
    "age": 23,
    "titleVi": "Học Nấu Ăn Mâm Cơm Truyền Thống",
    "descriptionVi": "Bạn học cách nấu những món ăn đặc sản quê hương: phở bò, bánh chưng ngày Tết, canh chua cá lóc.",
    "category": "family",
    "choices": [
      {
        "id": "yo_25_a",
        "textVi": "Học bí quyết nêm nếm gia vị từ mẹ, tự tay làm mâm cơm cúng tất niên",
        "outcomeTextVi": "Mâm cơm ấm cúng gắn kết cả gia đình trong niềm tự hào khôn xiết.",
        "healthDelta": 10,
        "happinessDelta": 25,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 30
      },
      {
        "id": "yo_25_b",
        "textVi": "Nấu cơm đãi người yêu và bạn bè vào dịp cuối tuần",
        "outcomeTextVi": "Tài nghệ bếp núc khéo léo khiến ai nấy đều tấm tắc khen ngợi.",
        "healthDelta": 10,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "yo_26_health_checkup",
    "stageKey": "youth",
    "age": 24,
    "titleVi": "Khám Sức Khỏe Tổng Quát Định Kỳ",
    "descriptionVi": "Sau những năm làm việc căng thẳng, bạn dành một buổi đi kiểm tra sức khỏe toàn diện.",
    "category": "health",
    "choices": [
      {
        "id": "yo_26_a",
        "textVi": "Lắng nghe bác sĩ tư vấn, điều chỉnh chế độ ăn giảm muối và ngủ đủ giấc",
        "outcomeTextVi": "Thể trạng được phục hồi sung mãn, ngăn ngừa sớm các bệnh mãn tính.",
        "healthDelta": 20,
        "happinessDelta": 15,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 5
      },
      {
        "id": "yo_26_b",
        "textVi": "Mua gói bảo hiểm sức khỏe trọn gói bảo vệ toàn diện bản thân",
        "outcomeTextVi": "Tâm lý an tâm vững vàng trước mọi rủi ro sức khỏe trong cuộc sống.",
        "healthDelta": 15,
        "happinessDelta": 15,
        "wealthDelta": -15,
        "intellectDelta": 10,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "yo_27_wedding_proposal",
    "stageKey": "youth",
    "age": 25,
    "titleVi": "Lễ Đính Hôn & Ra Mắt Hai Họ",
    "descriptionVi": "Hai bên gia đình chính thức gặp gỡ, trao trầu cau hẹn ngày cử hành hôn lễ trọng thể.",
    "category": "love",
    "choices": [
      {
        "id": "yo_27_a",
        "textVi": "Kính cẩn thưa chuyện với hai bên ông bà cha mẹ trong bầu khí đầm ấm",
        "outcomeTextVi": "Hai họ vui mừng chúc phúc, mối lương duyên được kết dệt bền chặt.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -20,
        "intellectDelta": 5,
        "relationsDelta": 35,
        "unlockRelationship": "Đã Đính Hôn Chính Thức",
        "addVirtue": "Hiếu kính hai bên cha mẹ và giữ gìn gia phong lễ giáo truyền thống"
      },
      {
        "id": "yo_27_b",
        "textVi": "Tự tay chuẩn bị sính lễ chu đáo, giản dị mà trang trọng",
        "outcomeTextVi": "Mọi người khen ngợi phong thái chỉn chu, chu đáo của bạn.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": -15,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "yo_28_age25_milestone",
    "stageKey": "youth",
    "age": 25,
    "titleVi": "Cột Mốc Tuổi 25 — Đứng Vững Bằng Đôi Chân Mình",
    "descriptionVi": "Tròn một phần tư thế kỷ cuộc đời, bạn nhìn lại hành trình đã qua và nhìn về tương lai với sự đĩnh đạc.",
    "category": "society",
    "choices": [
      {
        "id": "yo_28_a",
        "textVi": "Viết ra mục tiêu 10 năm tới: Gia đình hạnh phúc, sự nghiệp vững vàng, phụng sự tha nhân",
        "outcomeTextVi": "Kim chỉ nam rõ ràng giúp bạn vững bước vào giai đoạn trung niên rực rỡ.",
        "healthDelta": 10,
        "happinessDelta": 25,
        "wealthDelta": 10,
        "intellectDelta": 20,
        "relationsDelta": 20
      },
      {
        "id": "yo_28_b",
        "textVi": "Dâng lời tạ ơn Thiên Chúa và cha mẹ vì muôn ơn lành trong 25 năm qua",
        "outcomeTextVi": "Lòng biết ơn sâu sắc trở thành nguồn sức mạnh nâng đỡ bước chân bạn.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 25,
        "addVirtue": "Lòng tạ ơn sâu sắc về món quà sự sống và tình yêu thương nhận lãnh"
      }
    ]
  }
];
